var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 223310"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Add User",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Fill 1",
  d: "M47.753 18.97h-3.008v-2.941a2.248 2.248 0 1 0-4.495 0v2.941h-3a2.279 2.279 0 0 0 0 4.558h3v2.943a2.248 2.248 0 1 0 4.495 0v-2.943h3.008a2.279 2.279 0 0 0 0-4.558",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Fill 4",
  d: "M18.75 32.539C8.636 32.539 0 34.156 0 40.617s8.583 8.134 18.75 8.134c10.112 0 18.75-1.617 18.75-8.078s-8.583-8.134-18.75-8.134"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Fill 7",
  d: "M18.75 26.386a12.443 12.443 0 0 0 12.406-12.567 12.408 12.408 0 1 0-24.813 0A12.443 12.443 0 0 0 18.75 26.386",
  opacity: 0.4
})))));
export default SvgUser;